import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { Dispatch } from 'redux';
import { SET_AUTH_STATUS } from 'redux/actions';
import { API, request } from 'redux/api';
import { ROUTES } from 'routes';
import { removeSessionToken } from 'utils/session';

function logoutRequest() {
  return request<MessageResponse>({
    url: API.LTI_LOGOUT,
    method: 'POST',
  });
}

interface LogoutProps {
  logout(): Promise<void>;
}

const Logout: FC<LogoutProps> = ({ logout }) => {
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    logout().then(() => setIsLoggedOut(true));
  }, [logout]);

  if (!isLoggedOut) {
    return (
      <div className='message'>
        <p className='message__content'>Logging out...</p>
      </div>
    );
  }

  return (
    <Redirect
      to={{
        pathname: ROUTES.MESSAGE_PAGE,
        state: {
          code: 'SUCCESS',
          message: 'You have been logged out of Acadly, please refresh page to login again.',
        },
      }}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  logout: async () => {
    await logoutRequest();
    removeSessionToken();
    dispatch({
      type: SET_AUTH_STATUS,
      payload: false,
    });
  },
});

export default connect(null, mapDispatchToProps)(Logout);
